import React from "react";
import {
  Flex,
  Divider,
  Skeleton,
  Card,
} from "antd";

const SkeletonCpCard: React.FC = () => {
  return (
    <Card>
      <Flex gap="middle" flex={1} vertical={false} justify="space-between">
        <div>
          <Skeleton.Input active={true} style={{ height: "10px" }} />
          <Skeleton.Input active={true} block />
        </div>

        <div>
          <Skeleton.Input active={true} style={{ height: "10px" }} />
          <Skeleton.Input active={true} block />
        </div>
      </Flex>
      <br />
      <Flex gap="middle" flex={1} vertical={false} justify="space-between">
        <div>
          <Skeleton.Input active={true} style={{ height: "10px" }} />
          <Skeleton.Input active={true} block />
        </div>

        <div>
          <Skeleton.Input active={true} style={{ height: "10px" }} />
          <Skeleton.Input active={true} block />
        </div>
      </Flex>

      <Divider />
      <Skeleton.Input active={true} style={{ height: "10px" }} />
      <Flex gap="middle" flex={1} vertical={false} justify="space-between">
        <Skeleton.Input active={true} block />
      </Flex>
    </Card>
  );
};

export default SkeletonCpCard;
